<div class="agent-price-block">
    @switch (product()) {
        @case (productEnum.SellProduct) {
            @if (sellerSettings().commSource === commissionSource.Client) {
                <div class="agent-price-block-row">
                    <div class="agent-price-block-label">{{ 'components.price-block.saleCommPct' | translate }}:</div>
                    <div class="agent-price-block-value">
                        <app-currency-value [value]="(price() / 100) * sellerSettings().saleCommPct" />
                    </div>
                </div>
            }
            <div class="agent-price-block-row">
                <div class="agent-price-block-label">{{ 'components.price-block.total' | translate }}:</div>
                <div class="agent-price-block-value">
                    <app-currency-value [value]="price() | totalPriceCalculate: product() | async" />
                </div>
            </div>
        }
        @default {
            @if (sellerSettings()) {
                @if (product() === productEnum.RegisterCard) {
                    <div class="agent-price-block-row">
                        <div class="agent-price-block-label">
                            {{ 'components.price-block.registerPrice' | translate }}:
                        </div>
                        <div class="agent-price-block-value">
                            <app-currency-value [value]="sellerSettings().registerPrice" />
                        </div>
                    </div>

                    @if (sellerSettings().commSource === commissionSource.Client) {
                        <div class="agent-price-block-row">
                            <div class="agent-price-block-label">
                                {{ 'components.price-block.saleCommPct' | translate }}:
                            </div>
                            <div class="agent-price-block-value">
                                <app-currency-value
                                    [value]="(sellerSettings().registerPrice / 100) * sellerSettings().saleCommPct" />
                            </div>
                        </div>
                    }
                }

                @if (product() === productEnum.SellCard) {
                    <div class="agent-price-block-row">
                        <div class="agent-price-block-label">{{ 'components.price-block.cardPrice' | translate }}:</div>
                        <div class="agent-price-block-value">
                            <app-currency-value [value]="sellerSettings().cardPrice" />
                        </div>
                    </div>

                    @if (sellerSettings().commSource === commissionSource.Client) {
                        <div class="agent-price-block-row">
                            <div class="agent-price-block-label">
                                {{ 'components.price-block.saleCommPct' | translate }}:
                            </div>
                            <div class="agent-price-block-value">
                                <app-currency-value
                                    [value]="(sellerSettings().cardPrice / 100) * sellerSettings().saleCommPct" />
                            </div>
                        </div>
                    }

                    @if (sellWithRegistrationFlag()) {
                        <div class="agent-price-block-row">
                            <div class="agent-price-block-label">
                                {{ 'components.price-block.registerPrice' | translate }}:
                            </div>
                            <div class="agent-price-block-value">
                                <app-currency-value [value]="sellerSettings().registerPrice" />
                            </div>
                        </div>

                        @if (sellerSettings().commSource === commissionSource.Client) {
                            <div class="agent-price-block-row">
                                <div class="agent-price-block-label">
                                    {{ 'components.price-block.saleCommPct' | translate }}:
                                </div>
                                <div class="agent-price-block-value">
                                    <app-currency-value
                                        [value]="
                                            (sellerSettings().registerPrice / 100) * sellerSettings().saleCommPct
                                        " />
                                </div>
                            </div>
                        }
                    }
                }

                @if (price() && sellerSettings().commSource === commissionSource.Client) {
                    <div class="agent-price-block-row">
                        <div class="agent-price-block-label">
                            {{ 'components.price-block.payCommPct' | translate }}:
                        </div>
                        <div class="agent-price-block-value">
                            <app-currency-value [value]="(price() / 100) * sellerSettings().payCommPct" />
                        </div>
                    </div>
                }

                <div class="agent-price-block-row">
                    <div class="agent-price-block-label">{{ 'components.price-block.total' | translate }}:</div>
                    <div class="agent-price-block-value">
                        <app-currency-value
                            [value]="
                                price()
                                    | totalPriceCalculate
                                        : product()
                                        : { sellWithRegistration: sellWithRegistrationFlag() }
                                    | async
                            " />
                    </div>
                </div>
            }
        }
    }
</div>
